import React from 'react'

import { Button, InlineMenu, SectionSubtitle } from '..'
import { useUser } from '../../context'
import { AdminNewUserType, Profesor, Student } from '../../types'
import { Spacer } from '../global'

const UserTypeSection = ({
  editedProfile,
  type,
  handleMenuChange,
}: {
  editedProfile: AdminNewUserType | Student | Profesor
  type: string | null
  handleMenuChange: (
    filterName: string,
    value: string | string[] | null,
  ) => void
}) => {
  const { onEditionMode, userRole } = useUser()
  const inNewUser = type === 'new-user' ? true : onEditionMode

  return (
    editedProfile && (
      <>
        <Spacer height={40} />
        <SectionSubtitle fontWeight={500} fontSize={16} lineHeight={21}>
          Rol
        </SectionSubtitle>
        <Spacer height={16} />
        <div className="buttons">
          <Button
            onClick={() => handleMenuChange('role', 'admin')}
            className={editedProfile.role === 'admin' ? 'active' : ''}
            label="Administrador"
          />

          <Button
            onClick={() => handleMenuChange('role', 'professor')}
            className={editedProfile.role === 'professor' ? 'active' : ''}
            label="Profesor"
          />

          <Button
            onClick={() => handleMenuChange('role', 'student')}
            className={editedProfile.role === 'student' ? 'active' : ''}
            label="Alumno"
          />
        </div>
        {/* <Spacer height={40} />
        <SectionSubtitle fontWeight={500} fontSize={16} lineHeight={21}>
          Genero
        </SectionSubtitle>
        <Spacer height={16} />
        <div className="buttons">
          <Button
            onClick={() => handleMenuChange('genre', 'Masculino')}
            className={editedProfile.genre === 'Masculino' ? 'active' : ''}
            label=" Masculino"
          />

          <Button
            onClick={() => handleMenuChange('genre', 'Femenino')}
            className={editedProfile.genre === 'Femenino' ? 'active' : ''}
            label="Femenino"
          />

          <Button
            label="Otro"
            onClick={() => handleMenuChange('genre', 'Otro')}
            className={editedProfile.genre === 'Otro' ? 'active' : ''}
          />
        </div> */}
        {/* <InlineMenu
          userType={userRole}
          menuName="genre"
          activeFilter={editedProfile.genre}
          setActiveFilter={(value) => handleMenuChange('genre', value)}
          isDisabled={!inNewUser}
          isProfile={true}
        /> */}
      </>
    )
  )
}

export default UserTypeSection
